<script setup lang="ts">
import { useMainStore } from '~/store/main/main.store'

const mainStore = useMainStore()
const nyTextShow = computed(() => mainStore.getNyTextShow)
const close = () => {
  mainStore.nyTextShow = false
}
</script>

<template>
  <div
    v-if="nyTextShow"
    class="ny-text white--bg subhead-6"
  >
    <div class="container ny-text__wrap d-flex align-center">
      <p class="ny-text__text">
        Дорогие посетители, 31 декабря и 1 января у нас выходные! Оставляйте заявку — 2 января мы вернёмся на работу и сразу вам перезвоним. <span class="ny-text__primary">С Новым годом!</span>
      </p>
      <div
        class="ny-text__close d-flex align-center justify-center"
        @click="close"
      >
        <img
          loading="lazy"
          src="@/assets/images/svg/close.svg"
          alt="close"
        >
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ny-text {
  padding: 4px 0;

  &__wrap {
    position: relative;
  }
  &__primary {
    color: var(--btn, color(primary));
  }
  &__text {
    margin-right: 16px;
    @media (max-width: getBreakpoint(mobile-lg)) {
      margin-right: 12px;
    }
    @media (max-width: getBreakpoint(mobile-md)) {
      margin-right: 8px;
    }
  }

  &__close {
    width: 32px;
    min-width: 32px;
    height: 32px;
    cursor: pointer;
    margin-left: auto;
    margin-top: -4px;
    margin-bottom: -4px;
    img {
      opacity: .7;
      transition: opacity .24s;
      width: 24px;
      height: 24px;
      @media (max-width: getBreakpoint(mobile-lg)) {
        width: 22px;
        height: 22px;
      }
      @media (max-width: getBreakpoint(mobile-md)) {
        width: 20px;
        height: 20px;
      }
    }

    &:hover {
      img {
        opacity: 1;
      }
    }
  }
}
</style>
